<template>
<div :class=" search_status ? 'index page_fenlei page_map page_iteminfo page_art page_limit': 'index page_fenlei page_art page_map page_iteminfo'">
    <!-- 顶部搜索 -->
    <div class="top_wrap">
        <div class="index_top top_nobg">
            <div class="PageSearch page-search">
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder">
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
        </div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <div>
                <div class="search_fenlei">
                    <div class="search_title">技艺分类</div>
                    <ul class="search_list clearfix">
                        <li :class="skill.isSelect?'search_item f-l active':'search_item f-l'" v-for="skill in skillList" :key="skill.id" @click="skillClick(skill)">{{skill.name}}</li>
                    </ul>
                </div>
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 内容区 -->
    <div class="con_jiangren">
        <!-- 匠人 列表 -->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="jiangren dingzhi">
                <div class="con" v-for="(tradesman,index) in tradesmanList" :key="index">
                    <div class="con_info clearfix">
                        <div class="thumb f-l" @click="toTradesmanShop(tradesman)">
                            <img :src="tradesman.thumb ? ($publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="">
                        </div>
                        <div class="f-l con_info_r">
                            <div class="art">
                                <div class="name slh_s">{{tradesman.nickname}}</div>
                                <div class="work" @click="toTradesmanWork(tradesman)">作品：<span class="nums">{{ tradesman.zuopin_num }}</span></div>
                            </div>
                            <!-- <div class="tag slh_s">国家级</div> -->
                            <div class="desc">
                                <div class="slh_s">{{ tradesman.auth_company }}</div>
                                <div class="slh_s">{{ tradesman.helpless_skill }}</div>
                            </div>
                        </div>
                    </div>
                    <div :class="'guanzhu guanzhu_no'" @click="toServe(tradesman)">聊一聊</div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan.png', // 搜索栏右侧图标
            search_value: '', // 搜索值
            placeholder: '请输入要搜索的匠人',
            righticon: process.env.BASE_URL + '/statics/images/search_gery_icon.png', // 搜索框搜索图标
            search_status: false,
            token: null,
            skillList: [],
            cateList: [],
            areaList: [],
            tradesmanList: [],
            finished: false,
            page: 1,
            size: 10,
            loading: true,
            type: this.$route.query.type, // 技艺类型
            dingzhiId: this.$route.query.dingzhiId
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        console.log(this.type,this.dingzhiId,this.$route)
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制匠人'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                    this.getSkillData()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
            this.getSkillData()
        }
        
    },
    methods: {
        clicksearchright() {
            this.search_status = !this.search_status
        },
        search() {
            this.page = 1
            this.tradesmanList = []
            this.getData()
        },
        // 获取列表
        getData() {
			console.log('this.page',this.page)
			// console.log('this.loading',this.loading)
			// console.log('this.finished',this.finished)
            var params = {
                token: this.token,
                page: this.page,
                size: this.size
            }
            if (this.type) {
                params.type = this.type
            }
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.keyword = this.search_value
            }
            // console.log('params', params)
            this.$api.dingzhi.tralist(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    if (list.length != 0) {
                        for (var i in list) {
                            this.tradesmanList.push(list[i])
                        }
                        this.page++;
                        this.finished = false
                        this.loading = false
                    } else {
                        // 数据全部加载完
                        this.finished = true
                        this.loading = true
                        return;
                    }
                } else {
                    this.finished = true
                    this.loading = true
                    this.$toast(res.message)
                }
            })
        },
        // 获取技艺分类列表
        getSkillData() {
            var params = {
                token: this.token
            }
            this.$api.tradesman.skill(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list
                    for (var i in list) {
                        if (list[i].id == this.type) {
                            list[i].isSelect = 1
                        } else {
                            list[i].isSelect = 0
                        }
                    }
                    this.skillList = list
                }
            })
        },
        // 匠人店铺
        toTradesmanShop(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.id
                    }
                })
            }
        },
        // 作品展
        toTradesmanWork(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/dingzhi/tradesman/works?tra_uuid=' + tradesman.tra_uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/tradesman/works',
                    query: {
                        tra_uuid: tradesman.tra_uuid
                    }
                })
            }
        },
        // 点选匠人技艺  单选
        skillClick(skill) {
            var skillList = this.skillList
            skill.isSelect = !skill.isSelect
            for (var i = 0; i < skillList.length; i++) {
                if (skillList[i].id == skill.id) {
                    if (skill.isSelect) {
                        skillList[i].isSelect = 1
                        this.type = skillList[i].id
                    } else {
                        skillList[i].isSelect = 0
                        this.type = null
                    }

                } else {
                    skillList[i].isSelect = 0
                }
            }
        },
        // 重置
        reset() {
            for (var i in this.skillList) {
                this.skillList[i].isSelect = 0
            }
            this.type = null
        },
        // 确定
        submit() {
            this.search_status = false
            this.page = 1
            this.tradesmanList = []
            this.getData()
        },
        //聊一聊
        toServe(tradesman) {
            console.log(tradesman)
            // return
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo",memberParams,(data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        var params = {
                            token: this.token,
                            uuid: tradesman.tra_uuid,
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo,tradesman);
                            }
                        })
                    }
                });             
            } else {
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                    })
                    return
                }
                this.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: tradesman.tra_uuid,
                        dingzhiId: this.dingzhiId
                    }
                })
                // this.$router.push({
                //     path: '/system/develop'
                // })
            }
        },
        toAppServe(tradesmanInfo,tradesman) {
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesman.thumb,
                    toName: tradesman.nickname,
                    toUUID: tradesman.tra_uuid,
                    dingzhiId: this.dingzhiId,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_iteminfo .con_jiangren {
    margin-top: 0;
    padding-top: 1.2rem;
    min-height: 100vh;
}

.page_iteminfo .jiangren.dingzhi {
    padding-top: 0;
}
</style>
